import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/agents/$slug/queue`: the queue moved into Activity; saved links still land there. */
export const Route = createFileRoute("/_app/agents/$slug/queue")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/agents/$slug/activity", params, replace: true });
  },
});
